import Button from "@/common/Button";
import CustomInput from "@/common/FormElements/CustomInput";
import SingleSelect from "@/common/FormElements/SingleSelect";
import React, { useEffect, useState } from "react";
import apiClient from "@/utils/apiClient";
import { AnyARecord } from "dns";
import { MdCall } from "react-icons/md";
import toast from "react-hot-toast";

const ContactForm = ({
  selectedId,
}: {
  selectedId: { id: number; service: string; label?: string };
}) => {
  const [formData, setFormData] = useState({
    name: "",
    phonenumber: "",
    description: "",
    services: "",
  });
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const payload = {
        name: formData.name,
        phonenumber: formData.phonenumber,
        description: formData.description,
        services: formData.services,
      };
      const res = await apiClient.post(apiClient.URLS.servicecustomlead, {
        ...payload,
      });

      if (res.status === 201) {
        setFormData({
          name: "",
          phonenumber: "",
          description: "",
          services: "Vaastu_Consultation",
        });
        toast.success("deatils submitted successfully");
      } else {
        console.error("Failed to create lead", res);
      }
    } catch (error) {
      console.log("error is", error);
    }
  };
  const validateInput = (name: string, value: string) => {
    switch (name) {
      case "name":
        return /^[A-Za-z\s]*$/.test(value);
      case "phonenumber":
        return /^[0-9]{10}$/.test(value);
      case "emailAddress":
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      default:
        return true;
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    if (!validateInput(name, value)) return;
    setFormData({ ...formData, [name]: value });
  };
  const handleSelectChange = (selectedOption: {
    id: number;
    service: string;
  }) => {
    setFormData({
      ...formData,
      services: selectedOption.service,
    });
  };
  const isServiceFixed = selectedId?.service === "Interiors";

  return (
    <div className="rounded-[10px] shadow-custom-card bg-white min-h-[inherit] h-full  p-6">
      <p className=" font-Gordita-Medium text-blue-500 flex gap-2 flex-row items-center justify-start text-xl mb-4">
        <MdCall className="inline" color="bg-blue-400" /> Talk to a{" "}
        {selectedId.label} Expert
      </p>
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col gap-2">
          <CustomInput
            name={"name"}
            label="Enter Your Name"
            labelCls="font-Gordita-Medium md:text-[16px] text-[12px] leading-[22.8px] text-[black]"
            type={"text"}
            value={formData.name}
            placeholder="Enter Your Name"
            onChange={handleInputChange}
            required
          />
          <CustomInput
            name={"phonenumber"}
            label="Enter Phone Number"
            labelCls="font-Gordita-Medium md:text-[16px] text-[12px] leading-[22.8px] text-[black]"
            type={"number"}
            placeholder="Enter Phone Number"
            onChange={handleInputChange}
            required
          />
          <CustomInput
            name={"description"}
            label="Enter Your Requirements"
            labelCls="font-Gordita-Medium md:text-[16px] text-[12px] leading-[22.8px] text-[black]"
            type={"textarea"}
            placeholder="Enter Requirements"
            rootCls=""
            onChange={handleInputChange}
            required
          />
          <div className=" hidden">
            <SingleSelect
              type="single-select"
              name="services"
              optionCls="text-[12px] font-Gordita-Medium"
              options={[
                { id: 1, service: "Residential Construction" },
                { id: 2, service: "Construction for Business" },
                { id: 3, service: "Interiors", disabled: true },
                { id: 4, service: "Furniture" },
                { id: 5, service: "Plumbing" },
                { id: 6, service: "Painting" },
                { id: 7, service: "Vaastu Consultation" },
                { id: 8, service: "Civil Engineering Design" },
              ]}
              selectedOption={selectedId}
              optionsInterface={{ isObj: true, displayKey: "service" }}
              handleChange={(name, value) => {
                if (!isServiceFixed) handleSelectChange(value);
              }}
              aria-haspopup="listbox"
              aria-expanded={Boolean(selectedId)}
              aria-labelledby="services-label"
              aria-activedescendant={
                selectedId ? `option-${selectedId}` : undefined
              }
              buttonCls={
                selectedId?.service === "Interiors"
                  ? "opacity-60 pointer-events-none cursor-not-allowed"
                  : ""
              }
              openButtonCls={
                selectedId?.service === "Interiors" ? "pointer-events-none" : ""
              }
            />
          </div>
          <Button
            type="submit"
            className="bg-[#5297FF] md:text-[16px] text-[14px] text-[#FFFFFF] font-Gordita-Medium py-2 rounded-[6px] mt-4"
          >
            Get Free Quote
          </Button>
        </div>
      </form>
    </div>
  );
};
export default ContactForm;
